import * as Scrivito from "scrivito";
import TableCellWidgetComponent from "../TableCellWidget/TableCellWidgetComponent";

function PlainTableRowWidgetComponent({
  rowWidget,
  headers,
  firstColumnAsHeader,
}) {
  return (
    <tr>
      {rowWidget.get("cells").map((cellWidget, idx) => (
        <TableCellWidgetComponent
          key={`${cellWidget.id()}-${idx}`}
          widget={cellWidget}
          header={headers[idx]}
          alignment={rowWidget.get("verticalAlignment") || "top"}
          asHeader={firstColumnAsHeader && idx === 0}
        />
      ))}
    </tr>
  );
}

const TableRowWidgetComponent = Scrivito.connect(PlainTableRowWidgetComponent);

export default TableRowWidgetComponent;
